import { APP_CONFIG } from 'services/app-config'

export const CONFIG = {
  api: {
    logistic: `${APP_CONFIG.care_cluster}/ms-logistic-360/logisticInformation`,
  },
}
